
export interface QuestionPerformancePayload {
    schoolCode: string;
    familyCode: string;
    login: string;
    dicCode: string;
    lsnTestCode: string;
    sessionId: number;
    lsnCode?: string;
    qnNo: string;
    subNo: number;
    qnType: string;
    marks: number;
    noOfOptions: number;
    optOrder?: string;
    enteredCorrectAnswer: string;
    enteredWrongAnswer: string;
    enteredBlankAnswer: string;
    solutionSeen: string | number;
    clueSeen: boolean | string;
    principleSeen: boolean | string;
    questionLoadTime: number;
    questionAnswerTime: number;
    lastQnInd: number;
    varValues?: string;
    scoringMethod?: number | null;
    allQuestionsCompleted?: string;
    chapterCode?: string;
    unitCode?: string;
    hwid?: number | null;
    subject?: string;
}

const apiUrl = process.env.REACT_APP_DOCUMENT_LINK || "http://4.147.225.158:3001/";


export const saveQuestionPerformance = async (payload: QuestionPerformancePayload): Promise<any> => {
    try {
        const accessToken = sessionStorage.getItem('access_token');

        if (!accessToken) {
        }
        
        const apiPayload = {
            ...payload,
            solutionSeen: typeof payload.solutionSeen === 'boolean' ? (payload.solutionSeen ? 'Y' : 'N') : payload.solutionSeen,
            clueSeen: typeof payload.clueSeen === 'boolean' ? (payload.clueSeen ? 'Y' : 'N') : payload.clueSeen,
            principleSeen: typeof payload.principleSeen === 'boolean' ? (payload.principleSeen ? 'Y' : 'N') : payload.principleSeen,
        };

        const response = await fetch(`${apiUrl}update_question_performance/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${accessToken}`,
            },
            body: JSON.stringify(apiPayload),
        });

        if (!response.ok) {
            window.location.replace("/timeout");

            console.error("API Error Response:V1`", response);

            let errorData;
            try {
                errorData = await response.json();
                console.error("API Error Response:V2", errorData);
            } catch (e) {
                console.error("API Error Response:V3", e);
                errorData = { detail: `HTTP error ${response.status}: ${response.statusText}` };
            }
            console.error("API Error Response: V4", errorData);
            throw new Error(errorData.detail || errorData.message || 'Failed to save question performance.');
        }

        return await response.json();
    } catch (error) {
        console.error('Error saving question performance:', error);
        throw error;
    }
};